import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Ledger } from '../../../../models/ledger';

import { LedgerService } from '../../../../services/accounting/ledger.service';
import { NotyService } from '../../../../services/common/noty.service';
import { UserService } from '../../../../services/users/user.service';

declare var window: any;

@Component({
  selector: 'app-ledger-new',
  templateUrl: './ledger-new.component.html',
  styleUrls: ['./ledger-new.component.scss'],
})
export class LedgerNewComponent implements OnInit {
  creatingAdjustments: boolean = false;

  creditSum: number = 0;

  debitSum: number = 0;

  ledgersToAdjust: Array<Ledger> = [];

  newLedger: Ledger = new Ledger();

  showNewForm: boolean = true;

  constructor(
    private ledgerService: LedgerService, 
    private notyService: NotyService,
    private userService: UserService) {}

  ngOnInit() {
    if(this.userService.navbarComponent){
      this.userService.navbarComponent.setAccountingMenu();
    }
  }

  addAdjustment(form: NgForm) {
    if (form.form.valid) {
      let month: number = this.newLedger.created_at.getMonth() + 1;
      this.newLedger.created_at_str = `${month < 10 ? `0${month}` : month}/${this.newLedger.created_at.getDate() < 10 ? `0${this.newLedger.created_at.getDate()}` : this.newLedger.created_at.getDate()}/${this.newLedger.created_at.getFullYear()}`;
      this.ledgersToAdjust.push(this.newLedger);
      this.newLedger = new Ledger();
      this.showNewForm = false;
      this.calculateTotals();
      this.notyService.notify('Adjustment added', 'success');
    } else this.notyService.notify('Please check form for correct inputs', 'warning');
  }

  calculateTotals() {
    this.debitSum = 0;
    this.creditSum = 0;
    for (let ledger of this.ledgersToAdjust) {
      if (ledger.category == 'credit') this.creditSum += ledger.amount || 0;
      else if (ledger.category == 'debit') this.debitSum += ledger.amount || 0;
    }
  }

  createAdjustments() {
    this.creatingAdjustments = true;
    this.ledgerService
      .createAdjustments(this.ledgersToAdjust)
      .then((response_json) => {
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Adjustments added successfully', 'success');
          if (response_json.entry_group_url) window.location.href = response_json.entry_group_url;
        } else {
          this.creatingAdjustments = false;
          this.notyService.notify(response_json.text || 'Error adding adjustments', 'error');
        }
      })
      .catch(() => {
        this.creatingAdjustments = false;
        this.notyService.notify('Error adding adjustments', 'error');
      });
  }

  editAdjustment(ledger: Ledger) {
    ledger.editing = true;
    this.calculateTotals();
  }

  removeAdjustment(index: number) {
    this.ledgersToAdjust.splice(index, 1);
    this.calculateTotals();
  }

  toggleNewAdjustment() {
    this.showNewForm = !this.showNewForm;
    if (this.showNewForm) this.newLedger = new Ledger();
  }

  updateAdjustment(ledger: Ledger) {
    ledger.editing = false;
    this.calculateTotals();
  }
}
